import React, { useState } from 'react';
import axiosInstance from '../../utils/axiosConfig';
import { toast } from 'react-toastify';
import IkonSecici from '../IkonSecici';

export interface MaddeOgesi {
    projeMaddeID: number;
    ikon?: string | null;
    metin: string;
    sira: number;
}

interface Props {
    projeID: number;
    kategori: string;
    ogeler: MaddeOgesi[];
    onChange: (ogeler: MaddeOgesi[]) => void;
}

// Proje Sayfası'ndaki ikonlu madde listelerinin (Dış Mekan, Konum/Çevre, İç Mekan,
// Sosyal Alanlar) ortak yöneticisi — "Havuz", "Otopark" gibi tek satırlık özellikler.
const MaddeYonetici: React.FC<Props> = ({ projeID, kategori, ogeler, onChange }) => {
    const [yeniMetin, setYeniMetin] = useState('');
    const [yeniIkon, setYeniIkon] = useState<string | null>(null);
    const [ekleniyor, setEkleniyor] = useState(false);

    const handleEkle = async () => {
        if (!yeniMetin.trim()) return;
        setEkleniyor(true);
        try {
            const res = await axiosInstance.post('/api/ProjeSayfa/madde', {
                projeID, kategori, ikon: yeniIkon, metin: yeniMetin.trim(), sira: 0,
            });
            onChange([...ogeler, res.data]);
            setYeniMetin('');
            setYeniIkon(null);
        } catch {
            toast.error('Madde eklenirken hata oluştu.');
        } finally {
            setEkleniyor(false);
        }
    };

    const handleSil = async (id: number) => {
        try {
            await axiosInstance.post(`/api/ProjeSayfa/madde/delete/${id}`);
            onChange(ogeler.filter(o => o.projeMaddeID !== id));
        } catch {
            toast.error('Silinirken hata oluştu.');
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
                {ogeler.map(oge => (
                    <div key={oge.projeMaddeID} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: '#f8fafc', border: '1px solid #f1f5f9', borderRadius: 8 }}>
                        <i className={oge.ikon || 'fas fa-check-circle'} style={{ color: '#cd6906', width: 16, textAlign: 'center' }}></i>
                        <span style={{ flex: 1, fontSize: 13, color: '#334155' }}>{oge.metin}</span>
                        <button type="button" onClick={() => handleSil(oge.projeMaddeID)} title="Sil"
                            style={{ background: 'none', border: 'none', color: '#f43f5e', cursor: 'pointer', padding: 4 }}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                ))}
                {ogeler.length === 0 && <div style={{ fontSize: 12.5, color: '#94a3b8', padding: '6px 0' }}>Henüz madde eklenmedi.</div>}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <IkonSecici value={yeniIkon} onChange={setYeniIkon} />
                <input
                    type="text"
                    placeholder="Örn: Yüzme Havuzu"
                    value={yeniMetin}
                    onChange={e => setYeniMetin(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleEkle(); } }}
                    style={{ flex: 1, padding: '8px 12px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 13, outline: 'none' }}
                />
                <button type="button" onClick={handleEkle} disabled={ekleniyor || !yeniMetin.trim()}
                    style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#cd6906', color: '#fff', fontSize: 12.5, fontWeight: 600, cursor: 'pointer', opacity: !yeniMetin.trim() ? 0.5 : 1 }}>
                    Ekle
                </button>
            </div>
        </div>
    );
};

export default MaddeYonetici;
